var _excluded = ["listings", "title", "media"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { withMedia } from 'react-media-query-hoc';
import { LargeCard } from '../../components/large-card';
import { OverlayCard } from '../../components/overlay-card';
import { SmallCard } from '../../components/small-card';
import { HorizontalSlide } from '../../components/horizontal-slide';
import { ShadowFrame } from '../../components/shadow-frame';
import * as styles from './home-page.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var withShadow = media => Component => props => media.desktop ? ___EmotionJSX(ShadowFrame, null, ___EmotionJSX(Component, props)) : ___EmotionJSX(Component, props);
var getCardComponent = _ref => {
  var media = _ref.media,
    listings = _ref.listings;
  if (media.mobile) {
    return SmallCard;
  }
  if (listings.length === 1) {
    return withShadow(media)(LargeCard);
  }
  return withShadow(media)(props => ___EmotionJSX(OverlayCard, _extends({
    size: listings.length === 2 ? 'large' : 'small'
  }, props)));
};
var BaseHomePage = _ref2 => {
  var _ref2$listings = _ref2.listings,
    listings = _ref2$listings === void 0 ? [] : _ref2$listings,
    _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? 'Property of the Week' : _ref2$title,
    _ref2$media = _ref2.media,
    media = _ref2$media === void 0 ? {
      mobile: true,
      desktop: false
    } : _ref2$media,
    props = _objectWithoutProperties(_ref2, _excluded);
  var ListingCard = getCardComponent({
    media,
    listings
  });
  return ___EmotionJSX("div", {
    css: styles.container
  }, media.mobile && ___EmotionJSX("h2", {
    css: styles.title
  }, title), ___EmotionJSX(HorizontalSlide, _extends({
    noScroll: media.desktop,
    component: ListingCard,
    listings: listings,
    title: title
  }, props)));
};
var HomePage = withMedia(BaseHomePage);
export { HomePage, BaseHomePage };